import React, { useState, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faChevronLeft, faChevronRight } from "@fortawesome/free-solid-svg-icons";
import "../assets/css/next.css";
import Papa from "papaparse";
import Loader from "react-loader";

const Next1 = () => {
    const [loaded, setLoaded] = useState(false);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImageIndex, setSelectedImageIndex] = useState(null);
    const visibleCount = 6;
    const navigate = useNavigate();

    const [images, setImages] = useState([]);

    useEffect(() => {
        const sheetURL =
            "https://docs.google.com/spreadsheets/d/e/2PACX-1vQJB4XDn4cM60lvPxxVwBp8--5AHiSti_X9DNNSbnH_L1SnzodWZRsBM2E8wFUKbdIzsdBQMga5x-Dr/pub?output=csv";

        Papa.parse(sheetURL, {
            download: true,
            header: true,
            complete: function (results) {
                const rows = results.data;

                // Clean empty rows
                const cleanRows = rows.filter((row) => row.travel);

                // Convert to usable list
                const parsedImages = cleanRows.map((row) => ({
                    src: row.travel,
                }));

                setImages(parsedImages);
                setLoaded(true);
            },
            error: function (error) {
                console.error("Error fetching data:", error);
                setLoaded(true);
            },
        });
    }, []);

    const imagesToShow = images.slice(0, visibleCount);

    const handleViewMore = () => {
        navigate("/list");
    };

    const showImage = (index) => {
        setSelectedImageIndex(index);
        setIsModalOpen(true);
        document.body.style.overflow = "hidden";
    };

    const closeModal = () => {
        setIsModalOpen(false);
        document.body.style.overflow = "auto";
    };

    const handlePrev = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => 
            prevIndex === 0 ? images.length - 1 : prevIndex - 1
        );
    };

    const handleNext = (e) => {
        e.stopPropagation();
        setSelectedImageIndex((prevIndex) => 
            prevIndex === images.length - 1 ? 0 : prevIndex + 1
        );
    };



    return (
        <div className="our-upcoming-section text-center">
            <div className="container">

                {/* Heading */}
                    <div className="tour-dreams">
                        <h1 className="normal-text1">
                            Upcoming <span className="colGreen1">
                                Trips
                                <p className="LineSVG1">
                                    <img src="images/line-vector.png" alt="line" />
                                </p>
                            </span>
                        </h1>
                    </div>

                {/* GALLERY GRID */}
                <Loader loaded={loaded}>
                    <div className="row mx-0 mx-md-2 our-trip-images">
                        {imagesToShow.map((image, index) => (
                            <div
                                key={index}
                                className="col-lg-4 col-md-4 col-sm-6 col-6 px-1 px-md-3"
                                onClick={() => showImage(index)}
                            >
                                <img
                                    src={image.src}
                                    alt="Gallery"
                                    className="upcome-img col-lg-11 mb-4"
                                />
                            </div>
                        ))}
                    </div>

                    {/* VIEW MORE BUTTON */}
              
                        <div className="col-12 text-center">
                            <button className="upcome-viewmore-btn" onClick={handleViewMore}>
                                View More
                            </button>
                        </div>
                   

                    {/* MODAL */}
                    <div className="modal gallery-mobile" style={{ display: isModalOpen ? "flex" : "none", backgroundColor: "transparent", backdropFilter: "blur(5px)", width: "100%", margin: "auto", zIndex: '999999' }}>

                        <div className="trip-container" style={{ position: 'relative', alignItems: 'center', justifyContent: 'center' }}>
                            
                            <button 
                                onClick={handlePrev} 
                                style={{
                                    position: 'absolute',
                                    left: '20px',
                                    zIndex: 1000,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronLeft} />
                            </button>

                            {/* MAIN SELECTED IMAGE */}
                            <div className="selectedimgtrip">
                                {images[selectedImageIndex] && (
                                    <LazyLoadImage src={images[selectedImageIndex].src} alt="Selected" />
                                )}
                            </div>

                            <button 
                                onClick={handleNext} 
                                style={{
                                    position: 'absolute',
                                    right: '20px',
                                    zIndex: 1000,
                                    background: 'rgba(0, 0, 0, 0.5)',
                                    color: 'white',
                                    border: 'none',
                                    borderRadius: '50%',
                                    width: '40px',
                                    height: '40px',
                                    cursor: 'pointer',
                                    display: 'flex',
                                    alignItems: 'center',
                                    justifyContent: 'center'
                                }}
                            >
                                <FontAwesomeIcon icon={faChevronRight} />
                            </button>

                            <span className="close-trip" onClick={closeModal}>X</span>

                        </div>
                    </div>
                </Loader>
            </div>
        </div>
    );
};

export default Next1;
